import {PaymentTypes} from "shared-types/index";

const NS = 'PaymentTypeLabelFilter';

export default function PaymentTypeLabelFilter() {
  "ngInject";

  return function(paymentType) {
    switch (paymentType) {
      case PaymentTypes.NoPayment:
        return 'No Payment';
      case PaymentTypes.Deposit:
        return 'Deposit';
      case PaymentTypes.FullPayment:
        return 'Full Payment';
      case PaymentTypes.PreAuth:
        return 'Pre Authorisation';
      case PaymentTypes.FunctionPayment:
        return 'Function Payment';
      case PaymentTypes.MenuOptions:
        return 'Booking Options';
    }
    return paymentType;
  };
}
